





















































import { Component, Prop } from 'vue-property-decorator';
import { StarIcon, FileTextIcon } from 'vue-feather-icons';
import { ITask, TaskStatus } from 'admiral-core';
import dayjs from 'dayjs';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import PolicyEmbeddedTaskList from '@/components/tasks/PolicyEmbeddedTaskList.vue';
import { mixins } from 'vue-class-component';

@Component({
  components: {
    Avatar,
    StarIcon,
    FileTextIcon,
    PolicyEmbeddedTaskList,
  },
})
export default class UpcomingTasksCard extends mixins(BaseMixin, PermissionMixin) {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) subtitle!: string;
  @Prop({ type: Array, default: () => [] }) tasks!: ITask[];

  activeTab: 'today' | 'week' | 'overdue' = 'today';

  get currentTasks() {
    const list =
      this.activeTab === 'today'
        ? this.todayTasks
        : this.activeTab === 'week'
        ? this.weekTasks
        : this.activeTab === 'overdue'
        ? this.overdueTasks
        : [];

    return [...list].sort((a, b) => {
      const dateA = dayjs(a.dueAt);
      const dateB = dayjs(b.dueAt);
      return dateA.valueOf() - dateB.valueOf();
    });
  }

  get todayTasks() {
    return this.tasks.filter((task) => {
      if (!task.dueAt || task.status === TaskStatus.COMPLETED || task.status === TaskStatus.ARCHIVED)
        return false;
      return dayjs(task.dueAt).isSame(dayjs(), 'day');
    });
  }

  get weekTasks() {
    return this.tasks.filter((task) => {
      if (!task.dueAt || task.status === TaskStatus.COMPLETED || task.status === TaskStatus.ARCHIVED)
        return false;
      const today = dayjs();
      const taskDate = dayjs(task.dueAt);

      return (
        (taskDate.isSame(today, 'day') || taskDate.isAfter(today, 'day')) &&
        taskDate.isSame(today, 'week')
      );
    });
  }

  get overdueTasks() {
    return this.tasks.filter((task) => {
      if (!task.dueAt || task.status === TaskStatus.COMPLETED || task.status === TaskStatus.ARCHIVED)
        return false;
      return dayjs(task.dueAt).isBefore(dayjs(), 'day');
    });
  }

  get limitedCurrentTasks() {
    return this.currentTasks.slice(0, 7);
  }

  formatDate(date: string | Date | undefined) {
    if (!date) return '';
    return dayjs(date).format('DD.MM.YY');
  }

  openEditTaskModal(evt: Event, task: ITask) {
    this.$nextTick(() => {
      this.$router.push({ name: 'tasks.edit', params: { id: task.id } });
    });
  }

  openEditTaskModal2(task: ITask) {
    this.$nextTick(() => {
      this.$router.push({ name: 'tasks2.edit', params: { id: task.id } });
    });
  }
}
